import { Section } from "components/Section"
import { useTranslator } from "components/Translator"
import { DescriptionsList, DescriptionItem } from "components/DescriptionsList"
import { ValueWithUnit } from "components/ValueWithUnit"
import * as BoatType from "enums/BoatType"

export const BoatGeneral = (props) => {
  const { boat } = props
  const translator = useTranslator()

  const subtypes = getBoatSubtypes(boat)

  return boat ? (
    <Section
      title={translator.trans(
        "BoatGeneral.mainBoatFeatures",
        null,
        "components",
      )}
    >
      <DescriptionsList>
        <DescriptionItem
          label={translator.trans("BoatGeneral.family", null, "components")}
          value={boat.family}
        />
        <DescriptionItem
          label={translator.trans("BoatGeneral.type", null, "components")}
          value={[boat.type, ...subtypes]}
        />
        <DescriptionItem
          label={translator.trans(
            "BoatGeneral.factoryYear",
            null,
            "components",
          )}
          value={boat.factoryYear}
        />
        <DescriptionItem
          label={translator.trans("BoatGeneral.material", null, "components")}
          value={boat.material}
        />
        <DescriptionItem
          label={translator.trans("BoatGeneral.brand", null, "components")}
          value={boat.brandNormalized}
        />
        <DescriptionItem
          label={translator.trans("BoatGeneral.model", null, "components")}
          value={boat.modelNormalized}
        />
        <DescriptionItem
          label={translator.trans("BoatGeneral.length", null, "components")}
          value={
            boat.length?.value ? <ValueWithUnit value={boat.length} /> : null
          }
        />
        <DescriptionItem
          label={translator.trans("BoatGeneral.width", null, "components")}
          value={
            boat.width?.value ? <ValueWithUnit value={boat.width} /> : null
          }
        />
        <DescriptionItem
          label={translator.trans("BoatGeneral.draftDepth", null, "components")}
          value={
            boat.draftDepth?.value ? (
              <ValueWithUnit value={boat.draftDepth} />
            ) : null
          }
        />
      </DescriptionsList>
    </Section>
  ) : null
}

const getBoatSubtypes = (boat) => {
  switch (boat.type.enum_value) {
    case BoatType.PROPULSION:
      return boat.typePropulsion

    case BoatType.LIGHT_SAIL:
      return boat.typeLightSail

    case BoatType.YACHT:
      return boat.typeYacht

    case BoatType.MOTOR_BOAT:
      return boat.typeMotorBoat

    default:
      console.warn(`Unknown boat type: ${boat.type.enum_value}`)
      return null
  }
}
